import React, { Component } from 'react';
import {Row, Col, Typography, Image, Carousel} from "antd";
import './partners.css';
import cisco from "../Partners/partners/cisco-hover.svg";
import lenovo from "../Partners/partners/lenovo-hover.svg";
import apc from "../Partners/partners/apc-hover.svg";
import fortinet from "../Partners/partners/fortinet-hover.svg";
import vmware from "../Partners/partners/vmvare-hover.svg";
import hp from "../Partners/partners/Hewlett_Packard_Enterprise_logo.svg.png";
import forcepoint from "../Partners/partners/forcepoint.png";
import veeam from "../Partners/partners/veeam-hover.svg";
import trippLite from "../Partners/partners/Tripp_Lite.png";
import milestone from "../Partners/partners/milestone-new.png";
import tableau from "../Partners/partners/tableau-new.png";
import ibm from "../Partners/partners/ibm-hover.svg";
import checkpoint from "../Partners/partners/checkpoint.png";
import extreame from "../Partners/partners/extreme.png";
import citrix from "../Partners/partners/citrix-hover.svg";
import dell from "../Partners/partners/dell.png";
import kaspersky from "../Partners/partners/kaspersky.png";
import microsoft from "../Partners/partners/microsoft.png";
import Texts from "../../../utils/Text";

import { CaretLeftFilled, CaretRightFilled } from '@ant-design/icons';
const { Text } = Typography;

export default class Partners extends Component {
    state = {
        isMobile: window.screen.width < 770,
        icons: [
            [cisco, lenovo, apc],
            [fortinet, vmware, hp],
            [microsoft, veeam, trippLite],
            [milestone, tableau, ibm],
            [forcepoint, checkpoint, extreame],
            [citrix, dell, kaspersky]
        ],
        links: [
            ['https://www.cisco.com', 'https://www.lenovo.com', 'https://www.apc.com'],
            ['https://www.fortinet.com', 'https://www.vmware.com', 'https://www.hpe.com'],
            [ 'https://www.microsoft.com', 'https://www.veeam.com', 'https://www.tripplite.com'],
            ['https://www.milestonesys.com', 'https://www.tableau.com', 'https://www.ibm.com'],
            ['https://www.forcepoint.com', 'https://www.checkpoint.com', 'https://www.extremenetworks.com'],
            ['https://www.citrix.com', 'https://www.dell.com', 'https://www.kaspersky.ru']
        ],
    };

    onChange = (currentSlide) => {
        console.log(currentSlide);
    };

  render() {
      const {icons, links, isMobile} = this.state;
      return (
          <div className="montserrat partners-content">
              <Row justify="center" style={{ fontSize: "36px", paddingTop: '100px', marginBottom: isMobile ? '40px' : '125px'}}>
                  <Text>{Texts('partners', 'title')}</Text>
              </Row>
              {isMobile ?
                  <Row style={{marginBottom: '100px'}}>
                      {icons.map((item,index) => (
                          item.map((icon, index2) => (
                              <Col span={12} className="ta-center">
                                  <a href ={links[index][index2]} target = "_blank">
                                      <Image value={icon} preview={false} src={icon} width={150} height={75} />
                                  </a>
                              </Col>
                          ))
                      ))}
                  </Row>
                  :
                  <Carousel style={{ width:'100%', height: '150px', margin: 'auto'}} autoplay arrows prevArrow={<CaretLeftFilled/>} nextArrow={<CaretRightFilled />}>
                      {icons.map((item, index) => (
                          <Row justify="center" key={index}>
                              {item.map((icon, index2) => (
                                  <Col className="partners-icons" span={7}>
                                      <a href ={links[index][index2]} target = "_blank">
                                          <Image value={icon} preview={false} src={icon} width={200} height={100} />
                                      </a>
                                  </Col>
                              ))}
                          </Row>
                      ))}
                  </Carousel>
              }
          </div>
          );
  }
}

